import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issues',
  templateUrl: './issues.component.html',
})
export class IssuesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
